var render = function render(_c, _vm) {
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      {
        staticClass: "col-md-6 col-sm-12 color-black font-16 font-weight-bold"
      },
      [_vm._v(" " + _vm._s(_vm.props.peiTransportationName) + " ")]
    ),
    _c("div", { staticClass: "col-md-6 col-sm-12 d-flex" }, [
      _c(
        "span",
        { staticClass: "font-14 color-secondary-6 font-weight-normal" },
        [_vm._v(" Acompañante: ")]
      ),
      _c("div", { staticClass: "color-black font-14 font-weight-bold ml-2" }, [
        _vm._v(
          " " + _vm._s(_vm.props.companionFlag === "1" ? "Si" : "No") + " "
        )
      ])
    ]),
    _c("div", { staticClass: "col-md-6 col-sm-12 d-flex" }, [
      _c(
        "span",
        { staticClass: "font-14 color-secondary-6 font-weight-normal" },
        [_vm._v(" Millaje: ")]
      ),
      _c(
        "div",
        { staticClass: "color-primary-2 font-14 font-weight-bold ml-2" },
        [_vm._v(" " + _vm._s(_vm.props.mileage || "-") + " ")]
      )
    ]),
    _c("div", { staticClass: "col-md-6 col-sm-12 d-flex" }, [
      _c(
        "span",
        { staticClass: "font-14 color-secondary-6 font-weight-normal" },
        [_vm._v(" Total: ")]
      ),
      _vm.props.peiTransportationName == "BECA"
        ? _c(
            "div",
            { staticClass: "color-primary-1 font-14 font-weight-bold ml-2" },
            [
              _vm._v(
                " " + _vm._s(_vm._f("price")(_vm.props.serviceDailyCost)) + " "
              )
            ]
          )
        : _c("p", [_vm._v(" - ")])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }